import Vue from 'vue'
import Vuex, {StoreOptions} from 'vuex'
import {RootState} from '@/types/store'
import {actions, getters, mutations, state} from '@/store/root'
import {auth} from '@/store/modules/auth'
import {sentinel} from '@/store/modules/sentinel'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const setup: StoreOptions<RootState> = {
  state, // root state
  getters, // root getters
  actions, // root actions
  mutations, // root mutations
  modules: {
    auth, // controls the user authentication
    sentinel, // pulling requests for notification
  },
  strict: debug,
}

export const store = new Vuex.Store<RootState>(setup)
